import Vue from "vue";
import Vuex from "vuex";
import Authenticate from "@/views/authenticate/authenticate.module";
import Dashboard from "@/views/dashboard/dashboard.module";
import Dashboard2 from "@/views/dashboard2/store/dashboard2.module";
import ExpandedDashboard from "@/views/expanded-dashboard/expanded-dashboard.module";
import Base from "@/views/base/base.module";
import Sidebar from "@/views/sidebar/sidebar.module";
import Survey from "@/views/sidebar/survey/survey.module";
import EmojiKey from "@/views/sidebar/emoji-key/emoji-key.module";
import Notification from "@/views/sidebar/notification/notification.module";
import Summary from "@/views/summary/summary.module";
import Research from "@/views/research/research.module";
import Participant from "@/views/sidebar/participant/participant.module";
import CommercialParticipant from "@/views/sidebar/commercial-participant/participant.module";
import ResearchData from "@/views/sidebar/research-data/research-data.module";
import WatchStatistics from "@/views/sidebar/watch-statistics/watch-statistics.module";
import { resetAllState } from "@/store/resetAllState";

Vue.use(Vuex);

const AUTH_STORAGE_KEY = "opiaid.auth.user";

function loadPersistedUser(): any {
  try {
    const raw = sessionStorage.getItem(AUTH_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

const persistedUser = loadPersistedUser();

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    Authenticate,
    Dashboard,
    Dashboard2,
    ExpandedDashboard,
    Base,
    Sidebar,
    Survey,
    EmojiKey,
    Notification,
    Summary,
    Research,
    Participant,
    ResearchData,
    WatchStatistics,
    CommercialParticipant
  },
  plugins: [resetAllState]
});

if (persistedUser) {
  store.commit("Authenticate/updateField", {
    path: "user",
    value: persistedUser
  });
}

store.subscribe((mutation, state: any) => {
  if (mutation.type === "Authenticate/updateField") {
    const user = state.Authenticate?.user;
    if (user && user.token) {
      sessionStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(user));
    } else {
      sessionStorage.removeItem(AUTH_STORAGE_KEY);
    }
  }
});

export default store;
